import Image from "next/image";
import React from "react";

const RegionTitle = ({ handleShowAreas, areas }) => {
  const selectedItems = Object.keys(areas).filter((key) => areas[key]);

  return (
    <div
      onClick={handleShowAreas}
      className="flex flex-col items-start gap-1 px-4 py-1.5 lg:border-r cursor-pointer border-[#ECEFF5]"
    >
      <span className="text-[#9DADC0] text-xs font-medium leading-normal tracking-[1.8px]">
        BÖLGE
      </span>
      <div className="flex items-center justify-between w-full">
        <span className="text-sm font-medium leading-normal tracking-tight text-themeBlack">
          {selectedItems.length === 0
            ? "Seçiniz"
            : `${selectedItems.length} seçildi`}
        </span>
        <Image src="/icons/down.svg" width={12} height={12} alt="icon" />
      </div>
    </div>
  );
};

export default RegionTitle;
